import React from "react";
import styles from "./AboutUs1.module.css";

const AboutUs1 = ({ aboutData }) => {
  if (!aboutData) return null;

  return (
    <section id="about" className={styles.section}>
      <div className={styles.container}>
        <div className={styles.grid}>
          
          {/* Image Side */}
          <div className={styles.imageSide}>
            <img src={aboutData.image} alt="About Us" className={styles.img} />
            <div className={styles.experienceBadge}>
                <span>12+ Years</span>
                <p>Of Excellence</p>
            </div>
          </div>

          {/* Text Side */}
          <div className={styles.textSide}>
            <span className={styles.topBadge}>About Our Agency</span>
            <h2 className={styles.title}>{aboutData.title}</h2>
            <p className={styles.description}>{aboutData.description}</p>
            
            <div className={styles.features}>
               <div className={styles.feature}>✅ Best Price Guarantee</div>
               <div className={styles.feature}>✅ Professional Tour Guides</div>
               <div className={styles.feature}>✅ 24/7 Customer Support</div>
            </div>

            <button className="btn btn-primary btn-lg mt-4">Discover More</button>
          </div>

        </div>
      </div>
    </section>
  );
};

export default AboutUs1;